import angular from 'angular';
import uiRouter from 'angular-ui-router';
import eventAddFormComponent from './eventAddForm.component';

let eventAddFormModule = angular.module('eventAddForm', [
  uiRouter
])

.component('eventAddForm', eventAddFormComponent)

.name;

export default eventAddFormModule;
